import React, { Component } from 'react';
import PropTypes from 'prop-types';
import parse, { domToReact } from 'html-react-parser';
import ReactGA from 'react-ga';
import { NavLink } from 'react-router-dom';
import Loading from '../common/Loading';
import utils from '../../lib/utils';

import './index.scss';

const getYoutubeId = (url) => {
  const regExp = /^.*(youtu.be\/|v\/|u\/\w\/|embed\/|watch\?v=|&v=)([^#&?]*).*/;
  const match = url.match(regExp);

  return match && match[2].length === 11 ? match[2] : null;
};

const parserOptions = {
  // eslint-disable-next-line react/prop-types
  replace: ({ type, name, attribs, children }) => {
    if (type === 'tag' && name === 'a' && attribs?.href?.startsWith('/app')) {
      // Notion links
      return (
        <NavLink to={attribs.href} className={'anchor-tag'}>
          {domToReact(children, parserOptions)}
        </NavLink>
      );
    } else if (
      type === 'tag' &&
      name === 'a' &&
      (attribs?.href?.endsWith('.zip') ||
        attribs?.href?.endsWith('.pdf') ||
        attribs?.href?.endsWith('.pdf'))
    ) {
      // Notion links
      return (
        <a
          href={
            'notion-static-pages/TrueLark - Help Center 59e8ab0007ad4658987597990a80a797/' +
            attribs.href
          }
        >
          {domToReact(children, parserOptions)}
        </a>
      );
      //
    } else if (
      type === 'tag' &&
      name === 'a' &&
      (attribs?.href?.startsWith('https://youtu') ||
        attribs?.href?.startsWith('https://www.youtu'))
    ) {
      // Notion links
      return (
        <iframe
          width="560"
          height="315"
          src={`https://www.youtube.com/embed/${getYoutubeId(attribs.href)}`}
          title="YouTube video player"
          frameBorder="0"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
          referrerPolicy="strict-origin-when-cross-origin"
          allowFullScreen
        />
      );
      // <iframe width="560" height="315" src=
    } else if (type === 'tag' && name === 'a') {
      // External links
      return (
        <a href={attribs.href} target="_blank" rel="noreferrer" className={'anchor-tag'}>
          {domToReact(children, parserOptions)}
        </a>
      );
    }
    if (type === 'tag' && name === 'img') {
      // Notion links
      console.log('attribs', attribs);
      if (attribs?.src?.startsWith('https')) {
        return (
          <img
            src={attribs.src}
            style={attribs?.style
              ?.split(';')
              .map((rule) => {
                const cssRule = rule.split(':');
                return {
                  [cssRule[0]]: cssRule[1],
                };
              })
              .reduce((res, curr) => {
                return {
                  ...res,
                  ...curr,
                };
              }, {})}
          />
        );
      } else if (attribs?.class === 'icon') {
        return (
          <img
            src={'notion-static-pages/' + attribs.src}
            className={attribs.class}
          />
        );
      } else {
        return (
          <img
            src={
              'notion-static-pages/TrueLark - Help Center 59e8ab0007ad4658987597990a80a797/' +
              attribs.src
            }
            style={attribs?.style
              ?.split(';')
              .map((rule) => {
                const cssRule = rule.split(':');
                return {
                  [cssRule[0]]: cssRule[1],
                };
              })
              .reduce((res, curr) => {
                return {
                  ...res,
                  ...curr,
                };
              }, {})}
          />
        );
      }
    }
    //
    return '';
  },
};

class Help extends Component {
  componentDidMount() {
    const { pageId, getHelp } = this.props;
    const initPage =
      pageId !== '/app/help'
        ? pageId.replace('/app/help/', '')
        : 'TrueLark - Help Center 59e8ab0007ad4658987597990a80a797.html';
    console.log('InitPageId', initPage);
    ReactGA.pageview(window.location.hash);
    ReactGA.event({
      category: 'User',
      action: 'Click on Help Tab',
      label: 'Help Page',
    });
    getHelp(initPage);
  }

  componentWillReceiveProps({ pageId }) {
    const { pageId: oldId, getHelp } = this.props;
    console.log('pageId', pageId);

    if (pageId != oldId) {
      console.log('pageId', pageId);
      if (pageId == '/app/help') {
        console.log('pageId 1', pageId);
        getHelp('TrueLark - Help Center 59e8ab0007ad4658987597990a80a797.html');
      } else {
        getHelp(pageId.replace('/app/help/', ''));
      }
    }
  }

  render() {
    const { content, error, loading, auth } = this.props;
    const features = utils.getCookie('features');

    return (
      <div className="help">
        <div className="card auto-height">
          <div className="card__content notion-pages">
            {loading && (
              <div className="card__content__loader">
                <Loading />
              </div>
            )}
            {/* {!loading && error && <div>{parse(error.toString())}</div>}  */}
            {!loading && content && parse(content, parserOptions)}
          </div>
        </div>
        {features && !features.includes('CONTACT_INFO_HIDDEN') &&
          <div className="card fixed-height">
            <div className="card__header">
              <span className="card__header__text">
                For any assistance contact us:
              </span>
            </div>
            <div className="card__content">
              <div className="help__contacts">
                <div className="help__contacts__details">
                  <p className="name">TrueLark Support</p>
                  <p className="email">
                    Email:{' '}
                    <a href="mailto:support@truelark.com">support@truelark.com</a>
                  </p>
                  <p className="phone">
                    Tel: <a href="tel:+1-408-582-7010">+1-408-582-7010</a>
                  </p>
                </div>
                <div className="help__contacts__details">
                  <p className="name">TrueLark Sales</p>
                  <p className="email">
                    Email:{' '}
                    <a href="mailto:sales@truelark.com">sales@truelark.com</a>
                  </p>
                  <p className="phone">
                    Tel: <a href="tel:+1-408-898-9660">+1-408-898-9660</a>
                  </p>
                </div>
              </div>
            </div>
          </div>
        }
      </div>
    );
  }
}

Help.defaultProps = {
  content: '',
  error: '',
  loading: false,
  pageId: '',
};

Help.propTypes = {
  content: PropTypes.string,
  error: PropTypes.string,
  loading: PropTypes.bool,
  getHelp: PropTypes.func.isRequired,
  pageId: PropTypes.string,
};

export default Help;
